var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClinicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84211 2.67093H6.22368M7.60526 2.67093H6.22368M6.22368 2.67093V1.09198H9.97368V8.19724M9.97368 8.19724H12.6065C12.6899 8.19724 12.77 8.23041 12.829 8.28944L14.9079 10.3683C15.2349 10.6953 15.2349 11.2255 14.9079 11.5525V11.5525V11.5525C14.5809 11.8795 14.0507 11.8795 13.7237 11.5525L12.4696 10.2984C12.388 10.2168 12.2773 10.1709 12.1619 10.1709H6.22368M9.97368 8.19724H5.40448C5.29714 8.19724 5.1942 8.1546 5.1183 8.07871L2.27632 5.23672C1.94931 4.90971 1.41912 4.90971 1.09211 5.23672V5.23672V5.23672C0.765094 5.56373 0.765094 6.09392 1.0921 6.42093L4.5617 9.89052C4.74124 10.0701 4.98475 10.1709 5.23865 10.1709H6.22368M9.97368 12.5393V14.9078M6.22368 10.1709V14.9078M11.1579 14.9078H4.84211",
    stroke: "#282829",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicIcon);
export default __webpack_public_path__ + "static/media/clinicIcon.64b6a2526beb159fe85cba6f43159977.svg";
export { ForwardRef as ReactComponent };